<template>
  <Container>
    <ContentLoader viewBox="0 0 311 141.5" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb">
      <rect x="0" y="0" rx="6" ry="6" width="96" height="117.5" />
      <rect x="107.5" y="0" rx="6" ry="6" width="96" height="117.5" />
      <rect x="215" y="0" rx="6" ry="6" width="96" height="117.5" />

      <rect x="121" y="129.5" rx="0" ry="0" width="68.5" height="12" />
    </ContentLoader>
  </Container>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { ContentLoader } from '@tencent/wphk-components-content-loader';
import Container from './container.vue';

export default defineComponent({
  name: 'ModuleSkeleton',
  components: {
    ContentLoader,
    Container,
  },
});
</script>
